import { useIdFromUrl } from '@framework/ui';
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';

// Parametri dell'URL
interface Params {
  moduleId?: string;
  submissionId?: string;
}

export function useSubmissionIdsFromUrl() {
  const match = useRouteMatch<Params>();
  const [urlModuleId] = useIdFromUrl({ match }, 'moduleId');
  const [urlSubmissionId] = useIdFromUrl({ match }, 'submissionId');

  return useMemo(
    () => ({
      urlModuleId,
      urlSubmissionId,
    }),
    [urlModuleId, urlSubmissionId],
  );
}
